module.exports = __webpack_public_path__ + "static/womens-health-b2bf85b6ac91e3e7586550e7a917f556.png";